import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("要查看的客户"),
      "show-search": "",
      "filter-option": _vm.filterOption,
      "option-filter-prop": "children"
    },
    on: {
      change: _vm.customerIdFun
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1), _c("a-card", {
    attrs: {
      title: _vm.$t("组织架构"),
      hoverable: false,
      bordered: true
    }
  }, [_c("el-input", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("关键字进行过滤")
    },
    model: {
      value: _vm.filterText,
      callback: function ($$v) {
        _vm.filterText = $$v;
      },
      expression: "filterText"
    }
  }), _c("el-tree", {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      data: _vm.data,
      props: {
        children: "children",
        label: "name"
      },
      "default-expand-all": "",
      "filter-node-method": _vm.filterNode,
      "expand-on-click-node": false,
      "highlight-current": true,
      "node-key": "id"
    },
    on: {
      "node-click": _vm.handleNodeClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        node
      }) {
        return _c("span", {
          staticClass: "custom-tree-node"
        }, [_c("a-tooltip", {
          staticClass: "label",
          attrs: {
            placement: "top",
            title: node.label
          }
        }, [_vm._v(" " + _vm._s(node.label) + " ")])], 1);
      }
    }])
  })], 1)], 1), _c("div", {
    staticClass: "rightBox"
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("员工列表"),
      hoverable: false,
      bordered: true
    }
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("工号/手机号/证件号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.search,
      callback: function ($$v) {
        _vm.$set(_vm.form, "search", $$v);
      },
      expression: "form.search"
    }
  })], 1), _c("a-form-item", [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("人员状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("离职")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("在职")) + " ")])], 1)], 1), _c("a-form-item", [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("岗位"),
      allowClear: ""
    },
    model: {
      value: _vm.form.postId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "postId", $$v);
      },
      expression: "form.postId"
    }
  }, _vm._l(_vm.postList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1), _c("a-form-item", [_vm.isAuth("home.companyWorkersBaseStore") ? _c("a-button", {
    staticClass: "select-bottom",
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.handleAdd(null);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增员工")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.tableHead,
      "data-source": _vm.tableData,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "statusName",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "isEdit",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun2(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return _c("div", {}, [_vm.isAuth("home.companyWorkersDetail") ? _c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "staffInfoHome",
                params: {
                  id: record.id,
                  type: 1,
                  structure: record.structureId,
                  customerId: record.customerId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e(), _vm.isAuth("home.companyWorkersBaseEdit") ? _c("a-button", {
          staticClass: "marginL15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "staffInfoHome",
                params: {
                  id: record.id,
                  type: 2,
                  structure: record.structureId,
                  customerId: record.customerId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.companyWorkersMigration") && record.status == 1 ? _c("a-button", {
          staticClass: "marginL15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "transferHome",
                params: {
                  id: record.id
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("迁移")))]) : _vm._e(), _vm.isAuth("home.companyWorkersApplyResign") && record.status == 1 ? _c("a-button", {
          staticClass: "marginL15",
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "quitHome",
                params: {
                  id: record.id
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("离职")))]) : _vm._e()], 1);
      }
    }])
  }, _vm._l(_vm.tableHead, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };